import React, { useRef } from 'react';
import { Subject } from 'rxjs';

import { LBSList, LBSToolbar, LibraryContent } from 'views/Librarystud/components';
import { useStyles } from './styles';
import { Divider } from '@material-ui/core';

export default () => {
  const classes = useStyles();

  const listDataChangeSubject = new Subject();

  return (
    <div className={classes.root}>
      <LBSToolbar
        listDataChangeObservable={listDataChangeSubject.asObservable()}
      />
      <Divider />  
      <div className={classes.content}>
        <LibraryContent />
      </div>
    </div>
  );
};
